var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.302,
    height: 14.002,
    viewBox: "0 0 14.302 14.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12833",
    "data-name": "Group 12833",
    transform: "translate(-1195.499 -11433.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_196",
    "data-name": "Union 196",
    d: "M13607.9,14009.141a.9.9,0,0,1-.9-.9v-11.194a.9.9,0,0,1,.9-.9h6.367a.906.906,0,0,1,.9.9v4.054l-3.843.007a1.591,1.591,0,0,0,0,3.183l3.843-.008v3.959a.906.906,0,0,1-.9.9Zm8.9-3.344a.6.6,0,0,1-.035-.848l1.525-1.659-6.877-.042a.615.615,0,0,1,0-1.23l6.765.042-1.593-1.467a.6.6,0,0,1,.813-.882l2.7,2.482a.6.6,0,0,1,.158.643.627.627,0,0,1-.126.226l-2.482,2.7a.591.591,0,0,1-.438.191A.6.6,0,0,1,13616.8,14005.8Z",
    transform: "translate(-12411 -2561.879)",
    fill: "#FFF",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignOut);
export default __webpack_public_path__ + "static/media/icon-sign-out.2c1d00ec.svg";
export { ForwardRef as ReactComponent };